const gtmErrorRegistration = (cinestar_club) => {
    dataLayer.push({
        event: 'registration',
        step: 'registration_error',
        cinestar_club: cinestar_club ? 'ano' : 'ne',
        _clear: true,
    })
}

export default gtmErrorRegistration
